import { ActivityDetail } from './daily-activity.type';
import IJobDetail, { IJobTitle } from './job.detail.type';
import { Pagination } from './pageable.type';

export interface IJobOptionsData {
  jobTitles: IJobTitle[];
  companyTypes: ICompanyType[];
}

export interface ICompanyType {
  id: number;
  name: string;
}

export enum ShiftStatus {
  OPEN = 'open',
  CONFIRMED = 'confirmed',
  PENDING = 'pending',
}

export enum ActivityTrackerView {
  DATE = 'date',
  WORKER = 'worker',
}

export enum ActivityFilters {
  UPCOMING = 'upcoming',
  ONBOARDING = 'onboarding',
  MARK_PAID = 'mark_paid',
  TO_APPROVE = 'to_approve',
  NO_CHECK_IN_OUT = 'no_check_in_out',
  NO_SUBMITTED_TIME = 'no_submitted_time',
}

export interface IActivityData {
  id: number;
  worker: string;
  status: string;
  onboarding: string;
  scheduledTime: string;
  checkIn: string;
  checkOut: string;
  submittedTime: string;
  totalHours: number;
  workPay: string;
  expensePay: string;
  totalPay: string;
  shiftPaid: boolean;
  date: string;
}

export interface IJobStatsList {
  results: IJobStats[];
}

export interface IJobStats {
  jobId: number;
  countReviewsMissed: number;
  countMissingHours: number;
  countApproveHours: number;
  countMarkPaid: number;
  countOnboardingPending: number;
  countAvailablePositions: number;
  countTakenPositions: number;
  countHiredWorkers: number;
  countPendingWorkers: number;
  countHiddenWorkers: number;
  countTotalShifts: number;
  countCheckIns: number;
  countCheckOuts: number;
  countPendingCheckIns: number;
  countPendingCheckOuts: number;
  countNewApplicants: number;
  countSuggestedWorkers: number;
  countConsideredWorkers: number;
}

export interface IJobListFilters {
  viewType: JobListViews;
  searchFilter: string;
  jobSearchType: IJobSearchType;
  period: IJobSearchPeriod;
  scope: IJobSearchScope;
  hiddenJobs?: boolean;
  newApplicantsOnly: boolean;
  dateRange: { startDate: Date | undefined; endDate: Date | undefined };
  openShifts?: boolean;
  onboarding?: boolean;
  noCheckInOut?: boolean;
  missingHours?: boolean;
  toApprove?: boolean;
  markPaid?: boolean;
  upcoming?: boolean;
}

export interface IJobNewApplicantsCounter {
  jobId: number;
  totalNewApplicants: number;
}

export interface NewApplicantsCounterResults {
  totalJobsWithNewApplicants: number;
  totalNewApplicants: number;
  jobs: IJobNewApplicantsCounter[];
}

export interface IJobShiftsResult {
  pagination: Pagination;
  jobShifts: IJobShiftsData[];
  jobs: IJobDetail[];
}

export interface IJobShiftsCounters {
  countOpenShifts: number;
  countOnboarding: number;
  countNoCheckInOut: number;
  countMissingHours: number;
  countToApprove: number;
  countMarkPaid: number;
}

export interface IJobShiftsData {
  date: string;
  jobId: number;
  jobShiftActivities: ActivityDetail[];
}

export enum IJobSearchType {
  ACTIVE_ALL = 'ACTIVE_ALL',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  ACTIVE_COMPANY = 'ACTIVE_COMPANY',
  PAST_COMPANY = 'PAST_COMPANY',
  PAST_MEMBER = 'PAST_MEMBER',
  ALL = 'ALL',
}

export enum IJobSearchPeriod {
  ACTIVE = 'ACTIVE',
  PAST = 'PAST',
  ALL = 'ALL',
}

export enum IJobSearchScope {
  MEMBER = 'MEMBER',
  COMPANY = 'COMPANY',
}

export enum JobListFiltersKeys {
  SEARCH_TEXT = 'searchText',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  SEARCH_TYPE = 'searchType',
  IS_ACTIVE = 'isActive',
  SCOPE = 'scope',
  NEW_APPLICANTS_ONLY = 'newApplicantsOnly',
  HIDDEN_JOBS = 'hiddenJobs',
  // Job Shifts Filters
  OPEN_SHIFTS = 'openShifts',
  ONBOARDING = 'onboarding',
  NO_CHECK_IN_OUT = 'noCheckInOut',
  MISSING_HOURS = 'missingHours',
  TO_APPROVE = 'toApprove',
  UPCOMING = 'upcoming',
  MARK_PAID = 'markPaid',
}

export enum JobListViews {
  JOBS = 'JOBS',
  SHIFTS = 'SHIFTS',
}

export enum JobQuickFilters {
  NEW_APPLICANTS = 'New Applicants',
  HIDDEN_JOBS = 'Hidden Jobs',
}

export enum JobShiftsQuickFilters {
  CURRENT_OPEN_SHIFTS = 'Current Open Shifts',
  UPCOMING = 'Upcoming',
  ONBOARDING = 'Onboarding',
  MARK_PAID = 'Mark Paid',
  TO_APPROVE = 'To Approve',
  NO_CHECK_IN_OUT = 'No Check In/Out',
  MISSING_HOURS = 'Missing Hours',
}
